import { BlogPostCard } from './BlogPostCard';
import type { PostSummary } from '../../lib/sanity';

type RelatedPostsProps = {
  posts: PostSummary[];
};

export function RelatedPosts({ posts }: RelatedPostsProps) {
  const validPosts = posts?.filter((post): post is PostSummary => post != null && post._id != null) ?? [];
  if (!validPosts.length) return null;

  return (
    <section className="related-posts mt-16 border-t border-white/10 pt-10">
      <h2 className="related-posts-title font-display m-0 text-[clamp(22px,2.5vw,28px)] leading-[1.1] tracking-[-0.02em] text-[#f2efea]">
        Related posts
      </h2>
      <div className="related-posts-grid mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {validPosts.map((post) => (
          <BlogPostCard key={post._id} post={post} />
        ))}
      </div>
    </section>
  );
}
